import { useCallback, useEffect, useState } from "react";
import { fetchAmazonMedia } from "../../api/amazonMedia";
import type { AmzMediaManifest } from "../../types/amazonMedia";
import { errorMessage } from "./helpers";

/** 画像ライブラリ（manifest.json）を読み込む */
export function useAmazonMedia() {
  const [data, setData] = useState<AmzMediaManifest | null>(null);
  const [error, setError] = useState<string | null>(null);
  const load = useCallback(async () => {
    setError(null);
    try {
      setData(await fetchAmazonMedia());
    } catch (e) {
      setError(errorMessage(e));
    }
  }, []);
  useEffect(() => {
    void load();
  }, [load]);
  return { data, error, reload: load };
}
